/* jshint esversion: 6, browser: true, devel: true, indent: 2, curly: true, eqeqeq: true, futurehostile: true, latedef: true, undef: true, unused: true */
/* global document */

// Import dependencies
import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'slick-carousel';


// Import style
import '../styl/site.styl';

function rot13(message) {
  var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var b = "nopqrstuvwxyzabcdefghijklmNOPQRSTUVWXYZABCDEFGHIJKLM";
  return message.replace(/[a-z]/gi, (c) => b[a.indexOf(c)]);
}

function decodeRot13() {
  $('.js-rot-13').each((index, element) => {
    $(element).text(rot13($(element).text()));
  });

  $('.js-rot-13-link').each((index, element) => {
    $(element).attr('href', rot13($(element).attr('href')));
  });
}

class Site {
  constructor() {
    this.mobileThreshold = 601;

    $(window).resize(this.onResize.bind(this));

    $(document).ready(this.onReady.bind(this));

  }

  onResize() {
  }

  onReady() {
    this.$body = $('body');
    this.$slickCarousel = $('.slick-carousel');

    decodeRot13();
    lazySizes.init();
    this.initCarousel();
  }

  initCarousel() {
    var _this = this;

    if (_this.$slickCarousel.length) {
      _this.$slickCarousel.slick({
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: false,
        dots: true,
        arrows: false,
        focusOnSelect: false,
        rows: 1,
        centerPadding: 0,
      });

      // this.bindCarouselToggles();
    }
  }


  bindCarouselToggles() {
    var _this = this;

    // active state to prevent duplicate clicks
    var carouselActive = false;

    if ($('.carousel-trigger').length) {
      $('.carousel-trigger').on('click', function(e) {
        if (!carouselActive) {
          carouselActive = true;

          var index = $(e.target).attr('data-index');

          // #main-container is set absolute and positioned
          // to prevent overflow scrolling while overlay
          // is open
          _this.scrollOffset = _this.$window.scrollTop();
          _this.$mainContainer.css('top', '-' + _this.scrollOffset + 'px');

          // go to slide of image clicked on
          _this.$slickCarousel.slick('slickGoTo', index, true);

          _this.$body.addClass('carousel-active');
        }
      });

      $('#carousel-overlay').on('click', function(e) {
        if (!$(e.target).hasClass('slick-arrow')) {
          _this.$body.removeClass('carousel-active');

          // reset scroll position
          _this.$window.scrollTop(_this.scrollOffset);

          carouselActive = false;
        }
      });
    }
  }

  fixWidows() {
    // utility class mainly for use on headines to avoid widows [single words on a new line]
    $('.js-fix-widows').each(function(){
      var string = $(this).html();
      string = string.replace(/ ([^ ]*)$/,'&nbsp;$1');
      $(this).html(string);
    });
  }
}

new Site();



// WEBPACK FOOTER //
// ./src/js/main.js